// Utility to parse API error responses for user-friendly error messages

export function parseApiError(err: any): string {
  if (!err) {
    return 'Unknown error';
  }
  if (err && err.message === 'Network Error') {
    return 'Network error: Unable to reach the server. Please check your internet connection or try again later.';
  }
  let errorMsg = 'Unknown error';
  if (err.response) {
    let apiData = err.response.data;
    if (typeof apiData === 'string') {
      const jsonStart = apiData.indexOf('{');
      const jsonEnd = apiData.lastIndexOf('}');
      if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
        const jsonString = apiData.substring(jsonStart, jsonEnd + 1);
        try {
          const parsed = JSON.parse(jsonString);
          if (parsed.result && parsed.result.message) {
            errorMsg = parsed.result.message;
          } else if (parsed.message) {
            errorMsg = parsed.message;
          }
        } catch (e) {
          errorMsg = apiData;
        }
      } else {
        errorMsg = apiData;
      }
    } else if (apiData && typeof apiData === 'object') {
      if (apiData.result && apiData.result.message) {
        errorMsg = apiData.result.message;
      } else if (apiData.message) {
        errorMsg = apiData.message;
      }
    }
  } else if (typeof err === 'string') {
    errorMsg = err;
  } else if (err?.message) {
    errorMsg = err.message;
  }
  return errorMsg;
}
